import {
  confirmAllBookingCancel,
  confirmOverQuotaChildCourses,
  confirmAllCourseChange,
  confirmAllWaitingCancel
} from './ConfirmMessageBoxes';
import { fiflboxApi } from '@/utils/api';
import _ from 'lodash';
import dateFns from 'date-fns';

export default {
  methods: {
    async askBeforeUpdateChildCourse() {
      const NOT_CHANGE =
        this.recurrenceFormChangeCount === 0 && this.formChangeCount === 0;
      const RECURRENCE_HAS_CHANGE =
        this.data.recurrence &&
        (this.formChangeCount > 0 ||
          this.recurrenceFormChangeCount > 0 ||
          this.isChangeSkipFormValue);

      let is_url_validate = true;

      if (!this.form.is_offline) {
        if (!this.form.online_course_url) {
          this.$message('양식을 빠짐없이 채워주세요');
          return 'STOP-MODIFY';
        }
        this.$refs['childCourseForm'].validate(valid => {
          is_url_validate = valid;
        });
      }

      if (!is_url_validate) {
        return 'STOP-MODIFY';
      }

      if (NOT_CHANGE) {
        if (this.isChangeSkipFormValue) {
          if (!this.data.recurrence) {
            return undefined;
          }
        } else {
          return 'DIALOG-CLOSE';
        }
      }

      if (RECURRENCE_HAS_CHANGE) {
        let confirmResult = await confirmAllCourseChange();
        switch (confirmResult) {
          case 'close':
            return 'STOP-MODIFY';
          case 'this-course':
            return 'MODIFY-THIS-COURSE';
          default:
            return 'MODIFY-ALL-COURSE';
        }
      } else {
        return undefined;
      }
    },
    async updateChildCourse(isRecursiveLogic) {
      const form = Object.assign({}, this.form);
      let isChange = false;
      if (!isRecursiveLogic) {
        const result = await this.askBeforeUpdateChildCourse();
        if (result === 'DIALOG-CLOSE') {
          return true;
        } else if (result === 'STOP-MODIFY') {
          return false;
        } else if (result === 'MODIFY-THIS-COURSE') {
          form.to_single = true;
        } else if (result === 'MODIFY-ALL-COURSE') {
          form.to_single = false;
        }
      }

      form.start = this.joinDatetime(
        this.presentData.day,
        this.presentData.time
      );

      if (this.recurrenceForm.frequency === 0) {
        form.to_single = true;
        if (this.data.dt !== this.data.start) {
          form.from_date = this.data.dt;
        }
      } else {
        form.recurrence = this.vaildateRecurrenceForm(this.recurrenceForm);
        form.from_date = this.data.dt;
      }

      if (form.to_single) {
        delete form.recurrence;
        const SINGLE_HAS_CHANGE = this.formChangeCount > 0;

        isChange = SINGLE_HAS_CHANGE;
      } else {
        // 1. 단일 수업에서 반복수업으로 변경하는 경우.
        if (!this.data.recurrence && form.recurrence) {
          isChange = this.formChangeCount > 0;
        }
        // 변경이전과 이후 모두 반복수업인 경우.
        else {
          isChange =
            this.recurrenceFormChangeCount > 0 || this.formChangeCount > 0;
        }
      }
      // 시간 변동이 있는 경우
      if (isChange && !isRecursiveLogic) {
        let booking_params = {
          child_course: form.id,
          status: ['BOOKED', 'WAITING', 'PASS']
        };
        if (form.to_single) {
          booking_params = {
            ...booking_params,
            dt: form.from_date
          };
        } else {
          booking_params = {
            ...booking_params,
            dt_after: form.from_date,
            dt_before: form.recurrence.until
          };
        }
        const { data: bookings } = await fiflboxApi.v1.getBookings(
          booking_params
        );

        if (bookings.length) {
          const bulkDeleteBookings = Object.values(_.groupBy(bookings, 'dt'))
            .map(bookingArr => bookingArr[0])
            .sort((bookingA, bookingB) => {
              return dateFns.compareAsc(bookingA.dt, bookingB.dt);
            });
          const result = await confirmAllBookingCancel(
            bulkDeleteBookings,
            this.isBookingSystem
          );
          if (!result) {
            return;
          }
        }
      }

      try {
        await fiflboxApi.v2.putChildCourses(form.id, form);

        // only work when after change course, time.
        if (isChange && !isRecursiveLogic) {
          let booking_params = {
            child_course: form.id,
            status: ['BOOKED', 'WAITING', 'PASS']
          };
          if (form.to_single) {
            booking_params = {
              ...booking_params,
              dt: form.from_date
            };
          } else {
            booking_params = {
              ...booking_params,
              dt_after: form.from_date,
              dt_before: form.recurrence.until
            };
          }

          // recheck there are any bookings after update
          const { data: bookings } = await fiflboxApi.v1.getBookings(
            booking_params
          );

          if (bookings.length) {
            const payload = {
              data: bookings,
              status: 'CANCELLED'
            };
            await fiflboxApi.v1.patchBulkBookingStatus(payload);
          }
        }

        return true;
      } catch (err) {
        if (err.response.status === 400) {
          switch (err.response.data.error_code) {
            case '100':
              this.is_quota_valid = false;
              break;
            case '101':
              const min = err.response.data.error_detail.min;
              const bookings = err.response.data.error_detail.courses;
              await confirmOverQuotaChildCourses(bookings, min);
              break;
            case '102':
              await this.$message(err.response.data.error_detail);
              break;
            case '103':
              const waitings = err.response.data.error_detail;
              const result = await confirmAllWaitingCancel(
                waitings,
                this.membershipSystem
              );
              if (result) {
                const isSuccess = await this.bulkCancelWaitings(waitings);
                if (isSuccess) {
                  return await this.updateChildCourse(isSuccess);
                }
                return false;
              }
              break;
            default:
              this.$message('양식을 빠짐없이 채워주세요.');
              break;
          }
        } else {
          this.$message('알 수 없는 오류입니다.');
        }
        return false;
      }
    },
    async bulkCancelWaitings(waitings) {
      const payload = {
        data: waitings,
        status: 'CANCELLED'
      };
      try {
        const { status } = await fiflboxApi.v1.patchBulkBookingStatus(payload);
        if (status === 200) {
          return true;
        }
        return false;
      } catch (err) {
        return false;
      }
    }
  }
};
